import { HttpClient } from '../../httpClient'
import { queryString } from '../../httpClient/queryString'
import type {
  OpalApi,
  OpalApiRequestParams,
  OpalApiResponseDocument,
} from '../../schema'

type ReadWorkspacesV3 = OpalApi<'ReadWorkspacesV3', 200>

type ReadWorkspaceV3Params = OpalApiRequestParams<'ReadWorkspaceV3'>
type ReadWorkspaceV3Response = OpalApiResponseDocument<'ReadWorkspaceV3', 200>

type ReadWorkspaceDefaultsV3Params =
  OpalApiRequestParams<'GetWorkspaceDefaultsV3'>
type ReadWorkspaceDefaultsV3Response = OpalApiResponseDocument<
  'GetWorkspaceDefaultsV3',
  200
>

export const readWorkspace = async (
  params: ReadWorkspaceV3Params
): Promise<ReadWorkspaceV3Response> => {
  const workspaceId = params.path.workspace_id
  const url = new URL(`/workspaces/v3/${workspaceId}`, window.location.origin)

  url.search = queryString({
    ...params.query,
  })

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}

export const readWorkspaces: ReadWorkspacesV3 = async (args = {}) => {
  const url = new URL('/workspaces/v3', window.location.origin)

  url.search = queryString(args.params?.query)

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}

export const readWorkspaceDefaults = async (
  params: ReadWorkspaceDefaultsV3Params
): Promise<ReadWorkspaceDefaultsV3Response> => {
  const workspaceId = params.path.workspace_defaults_id
  const url = new URL(
    `/workspaces/v3/workspace_defaults/${workspaceId}`,
    window.location.origin
  )

  return HttpClient()
    .get(url.toString())
    .then((res) => res.data)
}
